import { WBFlex, WBTypography } from '@admiin-com/ds-web';
import { TaskPropertyProps } from './types';
import { styled, Theme, useMediaQuery } from '@mui/material';

export const TaskPropertyMobile = (props: TaskPropertyProps) => {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md')
  );
  if (!isMobile || props.properties.length === 0) {
    return null;
  }
  return (
    <HeaderMobile>
      {props.properties.map((property) => (
        <WBTypography variant="body2" key={property.label}>
          <b>{property.label}</b>&nbsp;
          {property.value}
        </WBTypography>
      ))}
    </HeaderMobile>
  );
};
const HeaderMobile = styled(WBFlex)(({ theme }) => ({
  padding: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  flexDirection: 'column',
  background: theme.palette.background.paper,
  gap: theme.spacing(1),
  ...theme.typography.body2,
}));
